import * as _ from 'lodash'

type Qualities = Array<{
	quality: string
	width: number
	height: number
	url: string
	format: 'mp4' | 'webm'
	formats?: Array<string>
}>

export const sortByQuality = (qualities: Qualities) =>
	_.sortBy(qualities, (qualityItem) => parseInt(qualityItem.quality, 10))
